// extracted by mini-css-extract-plugin
module.exports = {"Loader":"LoadingCircle_Loader__rcTlw","load8":"LoadingCircle_load8__2x_6M"};